import React, { useContext, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DeleteProjectDialog } from './deleteProjectDialog'
import { TableRow, TableCell } from '@/components/ui/table'
import { Button } from '@/components/ui/button'
import { Pencil, Trash2 } from 'lucide-react'
import { ProjectSmallIcon } from '@/components/icons/Project'
import toast from 'react-hot-toast'
import { DashboardContext } from '@/context/DashboardContext'

interface ProjectProps {
  project: {
    id: string
    name: string
    method: string
    needs_count: number
    categories_count: number
    meetings_count: number
    description: string
    product: string
  }
  setOpenRenameDialog: (project: any) => void
}

export function Project({ project, setOpenRenameDialog }: ProjectProps) {
  const { deleteProject } = useContext(DashboardContext)
  const [showDeleteDialog, setShowDeleteDialog] = useState(false)
  const navigate = useNavigate()

  const handleDeleteProject = async () => {
    try {
      await deleteProject(project.id)
      setShowDeleteDialog(false)
      toast.success('Project deleted successfully')
    } catch (err) {
      console.error('error deleting project', err)
    }
  }

  const formatMethod = (method: string) => {
    switch (method) {
      case 'user_interviews':
        return 'User Interviews'
      case 'user_testing':
        return 'User Testing'
      case 'focus_group':
        return 'Focus Group'
      default:
        return 'Mixed Methods'
    }
  }

  return (
    <>
      {showDeleteDialog && (
        <DeleteProjectDialog
          handleDeleteProject={handleDeleteProject}
          projectId={project.id}
          projectName={project.name}
          handleClose={() => setShowDeleteDialog(false)}
        />
      )}
      <TableRow
        className="hover:bg-gray-50/50 cursor-pointer"
        onClick={(e) => {
          // Don't navigate if clicking on action buttons
          if ((e.target as HTMLElement).closest('.action-buttons')) {
            e.stopPropagation()
            return
          }
          navigate(`/project/${project.id}`)
        }}
      >
        <TableCell className="w-[250px]">
          <div className="flex items-center gap-2">
            <ProjectSmallIcon disabled={false} />
            <span className="font-medium">{project.name}</span>
          </div>
        </TableCell>
        <TableCell className="w-[150px]">{formatMethod(project.method)}</TableCell>
        <TableCell className="w-[100px] text-center">{project.meetings_count}</TableCell>
        <TableCell className="w-[100px]">
          <div className="flex gap-2 action-buttons">
            <Button
              onClick={() =>
                setOpenRenameDialog({
                  id: project.id,
                  name: project.name,
                  description: project.description,
                  method: project.method,
                  product: project.product,
                })
              }
              size="sm"
              variant="ghost"
              className="h-8 w-8 p-0"
            >
              <Pencil size={16} className="text-gray-600" />
            </Button>
            {/* <Button onClick={() => setShowDeleteDialog(true)} size="sm" variant="ghost" className="h-8 w-8 p-0">
              <Trash2 size={16} className="text-gray-600" />
            </Button> */}
          </div>
        </TableCell>
      </TableRow>
    </>
  )
}
